export default {
    computed: {},
    watch: {},
    methods: {
        getCurrentLocation(options) {
            return new Promise((resolve, reject) => {
                if (!navigator.geolocation)
                    return reject(
                        'Cannot identify your location. Ensure your browser is enabled for GeoLocation!'
                    )
                options = options || {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                }
                function success(pos) {
                    const crd = pos.coords

                    console.log('Your current position is:')
                    console.log(`Latitude : ${crd.latitude}`)
                    console.log(`Longitude: ${crd.longitude}`)
                    console.log(`More or less ${crd.accuracy} meters.`)
                    return resolve(pos)
                }

                function error(err) {
                    console.warn(`ERROR(${err.code}): ${err.message}`)
                    return reject(err)
                }
                navigator.geolocation.getCurrentPosition(
                    success,
                    error,
                    options
                )
            })
        },
        async getSignatureAddress() {
            try {
                const p = await this.getCurrentLocation()
                const lat = p.coords.latitude
                const long = p.coords.longitude
                const getAddress = await this.$store.dispatch(
                    'orders/geocodeStreet',
                    { lat, long }
                )
                return {
                    lat: p.coords.latitude,
                    long: p.coords.longitude,
                    signature_address: getAddress[0].display_name,
                }
            } catch (err) {
                console.error('getSignatureAddress ', err)
                return {
                    lat: null,
                    long: null,
                    signature_address: null,
                }
            }
        },
    },
}
